import { Card, LinearProgress, Text } from "@salt-ds/core";
import { PauseIcon, PlayIcon } from "@salt-ds/icons";
import React, { useEffect, useRef, useState } from "react";

interface audioTileProps {
    driverName: string;
    driverNumber: number;
    link: React.MediaHTMLAttributes<HTMLAudioElement>['src'];
    colour: string;
    lap?: string;
}

function formatTime(seconds) {
  const wholeSeconds = Math.floor(seconds);
  const mins = Math.floor(wholeSeconds / 60);
  const secs = wholeSeconds % 60;
  const formattedSecs = secs.toString().padStart(2, '0');
  return `${mins}:${formattedSecs}`;
}

export const AudioTile = ({driverName, driverNumber, link, lap, colour}: audioTileProps) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  // console.log("initial", audioRef);
  const onClick = () => {
    setPlaying((prev) => {
      if (prev) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      return !prev;
    });
    // console.log(audioRef);
  };
  const [time, setTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const x = setInterval(() => {
      setTime(audioRef.current?.currentTime);
      setDuration(audioRef.current?.duration);
    }, 1000 / 60);

    return () => {
      clearTimeout(x);
    };
  }, [setTime]);

  useEffect(() => {
  const audio = audioRef.current;
  if (!audio) return;

  const handleEnded = () => {
    setPlaying(false);
    setTime(0);
    audio.currentTime = 0;
  };

  audio.addEventListener("ended", handleEnded);
  return () => {
    audio.removeEventListener("ended", handleEnded);
  };
}, [audioRef]);

  return (
    <>
      <Card style={{borderStyle: "solid", borderWidth:"3px", borderColor:`#${colour}`, width:"100%"}}>
        {!playing ? (
          <PlayIcon onClick={onClick} />
        ) : (
          <PauseIcon onClick={onClick} />
        )}
        <Text styleAs="h3">
          <strong>{driverNumber} | {driverName}</strong>
        </Text>
        {(lap) &&
        <>
        {(lap === "Prior To Race Start") ? 
          <>
            <Text styleAs="h4">{lap}</Text>
          </> 
          : 
          <>
            <Text styleAs="h4">Lap: {lap}</Text>
          </>}</>
        
}
        <Text>
          {formatTime(time)} / {formatTime(duration)}
        </Text>
        <LinearProgress value={time} min={0} max={duration} hideLabel style={{paddingRight: "54px"}}/>
      </Card>

      <audio
        style={{ display: "none" }}
        ref={audioRef}
        controls
        src={link}
      >
        Your browser does not support the audio element.
      </audio>
    </>
  );
};
